/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import React from 'react';
import { Checkbox } from 'antd';
import { useIntl } from 'react-intl';

import QuestionForm, {
  QuestionFormValues,
} from '~components/atoms/Questions/QuestionForm';
import { useStyles } from '~src/hooks/useStyles';
import { DbQuestion } from '~src/types/db';
import { AnswerFormValues } from '~components/atoms/Questions/AnswerQuickForm';
import { IconPopup } from '~components/popups-modals/DetailsLayouts/components';
import AnswerForm from '~components/atoms/Questions/AnswerForm';
import IconButton from '~components/_common/IconButton/IconButton';

export interface CreateTenderAnswerProps {
  question: DbQuestion;
  answerFormValues: AnswerFormValues;
  onAnswerFormChange: (key: keyof AnswerFormValues, newValue: any) => void;
  reviseQuestionFormValues: QuestionFormValues;
  onQuestionRevisionFormChange: (
    key: keyof QuestionFormValues,
    newValue: any
  ) => void;
  isRevisionChecked: boolean;
  onRevisionCheckedChange: (newValue: boolean) => void;
}

export const CreateTenderAnswer: React.FC<CreateTenderAnswerProps> = ({
  question,
  answerFormValues,
  onAnswerFormChange,
  reviseQuestionFormValues,
  onQuestionRevisionFormChange,
  isRevisionChecked,
  onRevisionCheckedChange,
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <div css={styles.pageContainer}>
      <div css={styles.formContainer}>
        {/* Upper Part */}
        <div css={styles.detailsGrid}>
          <b css={styles.label}>
            {intl.formatMessage({
              id: 'full-name',
              defaultMessage: 'Full name',
            })}
          </b>
          <b css={styles.value}>{question.created_by?.full_name}</b>

          <b css={styles.label}>
            {intl.formatMessage({ id: 'email', defaultMessage: 'Email' })}
          </b>
          <b css={styles.value}>{question.created_by?.email}</b>

          <b css={styles.label}>
            {intl.formatMessage({
              id: 'questions-title',
              defaultMessage: 'Questions title',
            })}
          </b>
          <div css={styles.value}>
            {question.question ? (
              question.question
            ) : (
              <span>{intl.formatMessage({ id: 'qatab-question-empty' })}</span>
            )}
          </div>

          <div />
          <div css={styles.checkboxWrapper}>
            <Checkbox
              checked={isRevisionChecked}
              onChange={(e) => onRevisionCheckedChange(e.target.checked)}>
              {intl.formatMessage({ id: 'revise-question' })}
            </Checkbox>
            <IconPopup
              messageId={'revise-question-help'}
              headerId={'revised-question'}
            />
          </div>
        </div>

        {/* Revise Question Section */}
        {isRevisionChecked && (
          <div css={styles.revisionSection}>
            <QuestionForm
              formValues={reviseQuestionFormValues}
              handleValueChange={onQuestionRevisionFormChange}
              withUploadFiles={false}
              resetEnabled={true}
            />
          </div>
        )}

        {/* Answer Question Section */}
        <AnswerForm
          formValues={answerFormValues}
          handleValueChange={onAnswerFormChange}
          descriptionLabel={intl.formatMessage({ id: 'answer' })}
          withUploadFiles={false}
        />
      </div>
    </div>
  );
};

const styleFn = (theme: any) => ({
  pageContainer: css``,
  formContainer: css`
    display: flex;
    flex-direction: column;
  `,
  detailsGrid: css`
    display: grid;
    grid-template-columns: 25% 75%;
    row-gap: 15px;
    align-items: baseline;
    margin-bottom: 1rem;
  `,
  label: css`
    width: 100%;
    font-weight: bold;
  `,
  value: css`
    width: 100%;
    font-weight: bold;
  `,
  checkboxWrapper: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  revisionSection: css`
    display: flex;
    flex-direction: column;
    /* question left border */
    //padding-left: 20px;
    //border-left: 3px solid #e6e6e6;
    //border-top-left-radius: 15px;
    //margin-bottom: 1rem;
  `,
});
